import React from "react";
import { Card, Typography, Box } from "@mui/material";
import dictionary from '../../../Mobx/Dictionary';
import "./DictionaryCard.css";

const DictionaryCard = ({ data, isSelected = false, number }) => {
    const handleClick = () => {
        dictionary.setCurrent(null, null, data._id);
    };

    return (
        <Card
            className={`dictionary-card-ai ${isSelected ? "selected-ai" : ""}`}
            sx={{
                position: "relative",
                margin: "4px",
                px: "3px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "120px",
                cursor: "pointer"
            }}
            onClick={handleClick}
        >
            <Box sx={{ position: "absolute", top: -5, right: 2 }}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
                    {number}
                </Typography>
            </Box>
            <Typography variant="h6" component="div" dir="auto">
                {data.original}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontSize: "1.2rem" }} dir="auto">
                {data.trns}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.8rem" }} dir="auto">
                {data.pos}
            </Typography>
        </Card>
    );
};

export default DictionaryCard;
